  (function() { 
    var targetIso = "AU";     
    var targetPath = "/en-au";  
    var params = new URLSearchParams(window.location.search);
    if (params.get('stay') === 'true') {
        sessionStorage.setItem('geo_redirect_off', 'true');
    }

    // If "stay" preference is saved, stop the script.
    if (sessionStorage.getItem('geo_redirect_off')) {
        return;
    }

    // --- MARKET PROTECTION ---
    // If user is already on a localized URL (e.g. /en-uk, /en-ca, /en-au), STOP.
    // This ensures we ONLY redirect traffic on the US (Default) site.
    if (/^\/[a-z]{2}-[a-z]{2}/i.test(window.location.pathname)) {
      return;
    }

    // --- GEO CHECK & FORCE REDIRECT ---
    fetch(window.Shopify.routes.root + 'browsing_context_suggestions.json')
      .then(function(res) { return res.json(); })
      .then(function(data) {
        
        // If Shopify detects Australia...
        if (data.detected_values.country.handle === targetIso) {
           
           // Construct the new URL:
           // Origin + /en-au + Path + Query Parameters (?utm_source...)
           var newUrl = window.location.origin + 
                        targetPath + 
                        window.location.pathname + 
                        window.location.search; 
           
           // Force the redirect immediately
           window.location.replace(newUrl);
        }
      })
      .catch(function(err) {
        // Fail silently if API is blocked
      });
  })();